import AdminCompanyInfo from "./Components/AdminCompanyInfo";

export default AdminCompanyInfo;
